import 'css-chunksrc/client/pages/projectPage/kanbanPage/loader/styles.scss';export default {
  "loader": "_loader_vbffz_1"
};